"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSContract_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Location_1 = require("./Location");
var NHSContractPeriod_1 = require("./NHSContractPeriod");
var User_1 = require("./User");
var NHSContract_Factory = /** @class */ (function () {
    function NHSContract_Factory() {
    }
    NHSContract_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AutoRenew: model.AutoRenew,
            ContractName: model.ContractName,
            ContractNumber: model.ContractNumber,
            ContractOwnerId: model.ContractOwnerId,
            Location: Location_1.Location_Factory.CreateIncoming(model.Location),
            LocationId: model.LocationId,
            NHSContractPeriods: model.NHSContractPeriods && model.NHSContractPeriods.map(function (i) { return NHSContractPeriod_1.NHSContractPeriod_Factory.CreateIncoming(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            User: User_1.User_Factory.CreateIncoming(model.User),
        };
        return result;
    };
    NHSContract_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AutoRenew: model.AutoRenew,
            ContractName: model.ContractName,
            ContractNumber: model.ContractNumber,
            ContractOwnerId: model.ContractOwnerId,
            Location: Location_1.Location_Factory.CreateOutgoing(model.Location),
            LocationId: model.LocationId,
            NHSContractPeriods: model.NHSContractPeriods && model.NHSContractPeriods.map(function (i) { return NHSContractPeriod_1.NHSContractPeriod_Factory.CreateOutgoing(i); }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            User: User_1.User_Factory.CreateOutgoing(model.User),
        };
        return result;
    };
    return NHSContract_Factory;
}());
exports.NHSContract_Factory = NHSContract_Factory;
